import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import SectionItems from './SectionItems';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

class Sections extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            items: [],
            cartEMPTY: 'Y',
            section: props.match.params.id,
            SECTIONNAME: '',
            CUSTOMER_DET: ''
        };
    }

    fetchSectionPage(mode,section) {

        var id = localStorage.getItem('delCIRCLE');

        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        
        var that = this;
        fetch('https://m.donedelivery.in/api/sections_api.php?mode='+mode+'&id='+id+'&section='+section+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            var ITEMS = result.ITEMS;
            var SECTIONNAME = result.SECTIONNAME;
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;

            that.setState({ LOADING:false, items:ITEMS, SECTIONNAME:SECTIONNAME, CUSTOMER_DET:CUSTOMER_DET });
        });
    }

    inCartCallBack = () =>{

        let cartEMPTY = 'Y';
        let cart = localStorage.getItem('cartData');
        if(cart !== null && cart!=='{}')
            cartEMPTY = 'N';

        var that = this;
        that.setState({ cartEMPTY:cartEMPTY });
    }
    
    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
        }
    }

    componentWillReceiveProps(nextProps) {
        window.location.reload();
        //this.setState({ LOADING:true });
        //this.fetchSectionPage('SECTION',nextProps.match.params.id);
    }

    componentDidMount() {
        this.fetchSectionPage('SECTION',this.state.section);
    }

    render() { 
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = this.state.SECTIONNAME;
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';
        let AppHeaderSearch = ''; //this.state.SECTIONNAME;

        let props = {
            items: this.state.items,
            inCartCallBack: this.inCartCallBack,
        };

        return (
            <div>
                {this.state.LOADING && <Loader />}
                {this.state.SECTIONNAME!='' && <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch} />}
                <div id="appCapsule">
                    <div className="section pt-0 pb-2">
                        <div className="row">
                            {this.state.items.length>0 && <SectionItems {...props} />}
                        </div>
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default Sections;


// WEBPACK FOOTER //
// ./src/components/Sections.js